import React from "react";
const LatestNewsCom = (props) => {
  return (
    <div
      className="flex justify-between flex-col items-center xs:w-36 sm:w-44 lg:w-56 cursor-pointer"
      onClick={props.onClick}
    >
      <div
        style={{ backgroundColor: props.bgcolor }}
        className="rounded-full p-1"
      >
        <img
          src={props.latestNewsthubmail}
          className="xs:w-36 xs:h-[135px] sm:w-40 lg:w-52 rounded-full sm:h-40 lg:h-52 object-cover"
          alt={props.alt}
        />
      </div>
      <div className="flex justify-center items-start h-[25%] xs:pt-2 sm:pt-3 sm:pb-2 xs:pb-4 lg:pt-3">
        <div className="lg:max-w-56">
          <p className="uppercase text-secondary font-onestBold xs:text-sm line-clamp-2 sm:text-base xs:leading-4 lg:text-lg xl:text-xl text-center">
            {props.latestNewsTitle}
          </p>
          <p className="uppercase text-secondary font-onestRegular xs:text-xs sm:text-sm xs:leading-4 lg:text-base text-center">
            {props.position}
          </p>
        </div>
      </div>
    </div>
  );
};
export default LatestNewsCom;
